import type { CalculationType } from '../../../types';
import { useCalculations } from '../../calculations-context';
import { Divider } from '../../results/divider';
import { ResultPrimary } from './result-primary';
import { ResultSecondary } from './result-secondary';
import { useResultValueFormatter } from './use-result-value-formatter';

export type ResultProps = {
  calculation: CalculationType;
  value?: number | string;
  formatter?: (value?: number | string) => string;
};

export function Result({ calculation }: ResultProps) {
  const calculations = useCalculations();
  const value = calculations[calculation.id];
  const resultValue = (() => {
    if (!value?.trim()) {
      return '';
    }

    if (calculation.format?._mode === 'string') {
      return String(value);
    }

    const number = Number(value);
    if (!isNaN(number) && number !== Infinity) {
      return number;
    }

    return value;
  })();

  const valueFormatter = useResultValueFormatter();
  const formatValue = (value?: ResultProps['value']) =>
    valueFormatter(value, calculation.format);

  return (
    <>
      {
        {
          primaryResult: (
            <ResultPrimary
              value={resultValue}
              calculation={calculation}
              formatter={formatValue}
            />
          ),
          secondaryResult: (
            <ResultSecondary
              value={resultValue}
              calculation={calculation}
              formatter={formatValue}
            />
          )
        }[calculation.resultType]
      }

      {calculation.divider && <Divider />}
    </>
  );
}
